import haus from "./home.png";
import car from "./pickup-car.png";
import green from "./green.png";
import castle from "./castle.png";
import logo from "./logo.jpeg";
import image1 from "./Image1.jpeg";

export const OfferRundUmsHaus = {
  title: "Rund ums Haus ",
  description: `Entdecken Sie meinen erstklassigen Hausmeisterservice für
                  Arbeiten rund ums Haus! Ich biete Kehrdienst, das Leeren von
                  Papierabfallkörben, Entrümplungs- und Aufräumarbeiten,
                  Sperrgutabfuhr sowie Müllbeseitigung. Verlassen Sie sich auf
                  meine Kompetenz für ein sauberes und ordentliches Zuhause.`,
  services: [
    "Kehrdienst",
    "Papierabfallkörbe leere",
    "Zuverlässige Entrümpelungs- und Aufräumarbeiten – von der einfachen Haushaltsauflösung bis zur fachgerechten Räumung stark vernachlässigter Wohnungen (Messi Wohnungen)",
    "Sperrgutabfuhr",
    "Müllbeseitigung",
    "Abfluss Siphon reinigen",
    "Dachrinnenreinigung",
    "chönheits und Kleinstreparaturen",
  ],
  img: haus,
};

export const OfferRundImHaus = {
  title: "Rund im Haus",
  description: `Sie wollen eine perfekte Möbel oder Wandmontage. Kein Problem!
                  Ich scanne ihre Wand und richte ihre Möbel perfekt und sicher
                  mittels Laser aus.`,
  services: [
    "Lampen aufhängen",
    "Bilder aufhängen",
    "Gardinenmontage",
    "Möbelmontage",
    "Aufstellung und Inbetriebnahme von Haushaltsgeräten",
    "Dichtungswechsel an Wasserarmaturen",
    "Filterwechsel an Lüftungsanlagen",
    "Schließzylinder wechsel",
    "Leuchtmittelwechsel",
    "Möbelbeschläge einstellen/auswechseln",
    "Ausbesserungsarbeiten",
    "Tapezieren mit Raufaser ",
    "Sicheres Bohren ",
    "Ausbesserung von Silikonfugen",
    "Kleinstreparaturen",
  ],
  img: haus,
};

export const OfferServices = {
  title: "Services",
  description: `Machen Sie Ihr Leben einfacher mit meinem umfassenden
                  Serviceangebot! Egal ob Sie Unterstützung bei einem Umzug,
                  zuverlässige Kleintransporte, gründliche Treppenhausreinigung
                  oder flexible Botendienste und Besorgungen benötigen – ich bin
                  Ihr Partner für alltägliche Herausforderungen. Verlassen Sie
                  sich auf meine Professionalität und genießen Sie den Komfort
                  meiner vielseitigen Dienstleistungen`,
  services: [
    "Umzugshilfe",
    "Kleintransporte",
    "Treppenhausreinigung",
    "Botendienste",
    "Ausführung von Besorgungen",
  ],
  img: car,
};
export const OfferRundUmDenGarten = {
  title: "Rund um den Garten",
  description: `Entdecken Sie meinen erstklassigen Hausmeisterservice für
                  Gartenlandschaftspflege! Ob Rasenmähen, Unkrautentfernen,
                  Heckenschneiden, Rasensprengen oder Blumengießen – ich bringe
                  Ihre Grünfläche zum Strahlen. Vertrauen Sie auf meine
                  Expertise und genießen Sie einen gepflegten Garten ohne Mühe.
                  Ihr Gartenparadies wartet!`,
  services: [
    "Rasen mähen",
    "Unkraut entfernen",
    "Hecken schneiden",
    "Beseitigung von Verschnitt",
    "Gartenbewässerung",
    "Blumen gießen",
    "Installation von Rasenmährobotern",
  ],
  img: green,
};

export const OfferHüpfburgVerleih = {
  title: "Hüpfburg verleih",
  description: `Mieten Sie jetzt Ihre Hüpfburg für grenzenlosen Spaß! Ob
                  Selbstabholung oder als Rundum-sorglos-Paket mit Transport,
                  Aufbau und Aufsichtsperson – Einfach. Sicher. Riesenspaß für
                  jede Feier und eine garantie für leuchtende Kinderaugen!`,
  services: [
    "Selbstabholung",
    "Transport",
    "Aufstellung",
    "Optional mit Aufsichstperson",
    "Sicher und Fachgerecht",
  ],
  img: castle,
};
